class LoaderService {
  constructor() {
    this.queue = 0;
    this.listeners = [];
  }

  onChange(cb) {
    this.listeners.push(cb);
  }

  show() {
    this.queue += 1;
    this.notifyListeners(true);
  }

  notifyListeners(value) {
    this.listeners.forEach((listener) => listener(value));
  }

  hide() {
    this.queue -= 1;
    if (this.queue < 0) {
      this.queue = 0;
    }
    if (this.queue === 0) {
      this.notifyListeners(false);
    }
  }
}

const loaderService = new LoaderService();
export { loaderService };
